import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { errMsg } from '../../utils/format';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      navigate(user.mustChangePassword ? '/settings/profile' : '/dashboard');
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img src="/images/summit_logo.png" alt="Summit Fishing Equipment"
          style={{ width: '100%', maxWidth: 220, display: 'block', margin: '0 auto 24px' }} />
        <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 4, textAlign: 'center' }}>
          StockForge
        </h2>
        <p style={{ fontSize: 13, color: 'var(--text-tertiary)', textAlign: 'center', marginBottom: 24 }}>
          Sign in to your account
        </p>

        {error && (
          <div className="alert alert-danger" style={{ marginBottom: 16 }}>
            <i className="ti ti-alert-circle" />{error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" required autoFocus value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" required value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
          </div>
          <button className="btn btn-primary w-full" type="submit" disabled={loading}
            style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Link to="/forgot-password" style={{ fontSize: 13, color: 'var(--blue)' }}>
            Forgot my password
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: 'var(--page-bg)', padding: 20,
  },
  card: {
    background: 'var(--card-bg)', border: '0.5px solid var(--card-border)',
    borderRadius: 'var(--radius-lg)', padding: '32px 28px', width: '100%', maxWidth: 400,
    boxShadow: 'var(--shadow-md)',
  },
};
